/**
 * LimitsCard — PlanLimitsEditor as a self-contained block with its own
 * עריכה / ביטול / שמור bar. Saves planOverrides + legacy flat quota fields
 * via updateClinicField (usePlanOverrides.buildUpdates()).
 */

import { useState } from "react";
import { FloppyDisk, PencilSimple } from "@phosphor-icons/react";
import { useToast } from "../../../../../contexts/ToastContext";
import { useUpdateClinicFieldMutation } from "../../../../../store/services/nivApi";
import PlanLimitsEditor from "./PlanLimitsEditor";

export default function LimitsCard({ clinic, overrides, refetch }) {
  const { showSuccess, showError } = useToast();
  const [updateClinicField, { isLoading }] = useUpdateClinicFieldMutation();
  const [isEditing, setIsEditing] = useState(false);

  const handleCancel = () => {
    setIsEditing(false);
    overrides.resetFromClinic(clinic);
  };

  const handleSave = async () => {
    try {
      const updates = overrides.buildUpdates();
      if (Object.keys(updates).length > 0) {
        await updateClinicField({ clinicId: clinic.clinicId, fieldUpdates: updates }).unwrap();
      }
      setIsEditing(false);
      refetch?.();
      showSuccess("המגבלות נשמרו");
    } catch (error) {
      console.error("[CK-9815] Error saving clinic plan limits:", {
        errorCode: "CK-9815",
        errorMessage: error?.message,
        clinicId: clinic.clinicId,
        timestamp: new Date().toISOString(),
      });
      showError("שגיאה בשמירת המגבלות");
    }
  };

  return (
    <div className="ncd2-limits-block" id="ncd2-block-limits">
      <div className="ncd2-edit-bar">
        <span className="ncd2-muted ncd2-note">מגבלות בפועל של הקליניקה — חריגות מהמסלול מסומנות בדגל</span>
        {!isEditing ? (
          <button type="button" className="ncd2-btn ncd2-btn-secondary ncd2-btn-sm" onClick={() => setIsEditing(true)}>
            <PencilSimple size={14} /> עריכת מגבלות
          </button>
        ) : (
          <div className="ncd2-edit-actions">
            <button type="button" className="ncd2-btn ncd2-btn-ghost ncd2-btn-sm" onClick={handleCancel} disabled={isLoading}>
              ביטול
            </button>
            <button type="button" className="ncd2-btn ncd2-btn-primary ncd2-btn-sm" onClick={handleSave} disabled={isLoading}>
              <FloppyDisk size={14} /> {isLoading ? "שומר…" : "שמור מגבלות"}
            </button>
          </div>
        )}
      </div>
      <PlanLimitsEditor overrides={overrides} isEditing={isEditing} hidePlanPicker />
    </div>
  );
}
